(function () {
  function chicagoDay(ms) {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ms));
    } catch (e) {
      return '';
    }
  }

  function initSched(box) {
    if (box.hasAttribute('data-rw-ready')) return;
    var days = box.querySelectorAll('.rw-day');
    var bar = box.querySelector('.rw-tabs');
    if (!bar || days.length < 2) return;
    box.setAttribute('data-rw-ready', '');
    var uid = 'rw' + Math.random().toString(36).slice(2, 8);
    var today = chicagoDay(Date.now());
    var pick = -1, first = -1;
    var tabs = [];

    Array.prototype.forEach.call(days, function (d, i) {
      if (d.getAttribute('data-date') === today) pick = i;
      if (first === -1 && d.querySelector('.rw-rows')) first = i;
    });
    if (pick === -1) pick = first === -1 ? 0 : first;

    function select(n, focus) {
      tabs.forEach(function (t, i) {
        var on = i === n;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        days[i].hidden = !on;
      });
      if (focus) tabs[n].focus();
    }

    Array.prototype.forEach.call(days, function (d, i) {
      var name = d.getAttribute('data-rw-day') || '';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rw-tab';
      b.id = uid + '-t' + i;
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-controls', uid + '-p' + i);
      b.textContent = name.slice(0, 3);
      if (d.getAttribute('data-date') === today) b.className += ' is-today';
      d.id = uid + '-p' + i;
      d.setAttribute('aria-labelledby', b.id);
      b.addEventListener('click', function () { select(i, false); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = -1;
        if (k === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        if (n > -1) { e.preventDefault(); select(n, true); }
      });
      tabs.push(b);
      bar.appendChild(b);
    });
    bar.hidden = false;
    select(pick, false);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rw-sched]'), initSched);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-rwp-copy]');
    if (!c) return;
    var v = c.parentElement.querySelector('.rwp-gps-v');
    var t = v ? v.textContent.trim() : '';
    if (!t || !navigator.clipboard) return;
    navigator.clipboard.writeText(t).then(function () {
      c.textContent = 'Copied';
      setTimeout(function () { c.textContent = 'Copy'; }, 1500);
    });
  });
})();
